import Vue from 'vue'
import VueRouter from 'vue-router'
import YearInFilm from "@/views/YearInFilm";
import Login from "@/views/Login";
import Error from "@/views/Error";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Login,
    },
    {
        path: '/:year/:user_id/:token',
        name: 'YearInFilm',
        component: YearInFilm,
    },
    {
        path: '/error',
        name: 'Error',
        component: Error
    }
]

const router = new VueRouter({
    mode: 'history',
    routes,
})

export default router